<template>
  <div class="pt-2 manageshipment__wrapper2">
    <div
      class="_global__nodata d-flex justify-content-center align-items-center"
      v-if="inboundList && inboundList.length === 0"
    >
      <div class="text-center">
        <img src="@/assets/image/icon/nodata-older.svg" alt="" />
        <h4 class="pt-3">No archive found</h4>
      </div>
    </div>
    <!-- list -->
    <div
      v-for="item in inboundList"
      :key="item.id"
      class="bg-card-list mb-3 p-4"
    >
      <p class="col p-0 mb-3">
        <span class="pdetail__paragraph2"
          >Inbound ID : {{ item.inboundId || '-' }}</span
        >
      </p>
      <div class="d-flex align-items-center pb-2 mt-2">
        <div class="col-10 p-0 row p-0">
          <div class="col-6 border-right border-e1e1e1">
            <div class="d-flex mb-2">
              <p class="col pdetail__paragraph1">Warehouse</p>
              <p class="col d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.warehouseName || '-'
                }}</span>
              </p>
            </div>
            <div class="d-flex mb-2">
              <p class="col pdetail__paragraph1">Inbound Date</p>
              <p class="col d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.inboundDate ? getDateDefauld(item.inboundDate) : '-'
                }}</span>
              </p>
            </div>
            <div class="d-flex mb-2">
              <p class="col pdetail__paragraph1">Total SKU</p>
              <p class="col d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.totalSku || '-'
                }}</span>
              </p>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex mb-2">
              <p class="col pdetail__paragraph1">Nomor Pengajuan</p>
              <p class="col d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.nomorPengajuan || '-'
                }}</span>
              </p>
            </div>
            <div class="d-flex mb-2">
              <p class="col pdetail__paragraph1">Reference Number</p>
              <p class="col d-flex align-items-start">
                <span class="pdetail__paragraph2 mr-1">:</span>
                <span class="pdetail__paragraph2">{{
                  item.referenceNumber || '-'
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-2 p-0 ml-4">
          <template v-if="$route.params.type !== 'draft'">
            <button class="bluewhite mb-2" @click="seeDetail(item.id)">
              See Details
            </button>
            <button
              v-if="$route.params.type === 'waiting-inbound'"
              class="redwhite"
              @click="confrimModal(item.id)"
            >
              Cancel Inbound
            </button>
          </template>
          <template v-else>
            <button
              class="d-block bluewhite mb-2"
              @click="continueDraft(item.id)"
            >
              Continue Draft
            </button>
            <button class="d-block redwhite" @click="confrimModal(item.id)">
              Cancel Inbound
            </button>
          </template>
        </div>
      </div>
    </div>
    <!-- end list -->
    <div class="modals">
      <b-modal
        ref="confirmInbound"
        id="modalConfirmInbound"
        centered
        hide-footer
        title="Confirmation"
      >
        <div class="__body text-center">
          <p class="mb-2">Are you sure that you want to cancel this draft?</p>
          <div class="d-flex justify-content-center mt-4">
            <button
              class="button__redcorporite mr-3"
              @click="$refs.confirmInbound.hide()"
            >
              No
            </button>
            <button class="button__bluecorporite" @click="cancelData">
              Yes
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalPublishSuccess"
        ref="modalSuccessIQ"
        centered
        hide-footer
        title=""
      >
        <div>
          <div class="d-flex justify-content-center mb-2">
            <img
              style="width: 68px; height: 68px"
              src="@/assets/image/image/complete.png"
              alt=""
            />
          </div>
          <p class="text-center">
            Inbound has been canceled
          </p>
        </div>
        <div class="row mt-4">
          <div class="col-md text-center">
            <b-button
              @click="$refs.modalSuccessIQ.hide()"
              class="button__bluecorporite"
              >Ok
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinDateTime from '@/mixin/getters/date-time'

export default {
  name: 'inboundList',
  props: {
    inboundList: Array,
    selectedtabs: String
  },
  mixins: [mixinDateTime],
  data() {
    return {
      id: ''
    }
  },
  computed: {
    ...mapGetters({
      cancelInbound: 'warehouse/cancelInbound',
      isLoadingCancelInbound: 'warehouse/isLoadingCancelInbound',
      errorCancelInbound: 'warehouse/errorCancelInbound'
    })
  },
  methods: {
    continueDraft(id) {
      this.$router.push({
        name: 'Warehouse',
        params: {
          type: 'draft'
        },
        query: {
          id: id
        }
      })
    },
    cancelData() {
      this.$store.dispatch('warehouse/CANCEL_INBOUND', this.id).then(() => {
        if (!this.cancelInbound) {
          this.$refs.confirmInbound.hide()
          this.$refs.modalSuccessIQ.show()
          const filter = {
            skuId: '',
            inboundDate: ''
          }
          const { type } = this.$route.params
          const currentPage = 1
          const perPage = 10
          this.$store.dispatch('warehouse/FETCH_INBOUND_LIST', {
            type,
            currentPage,
            perPage,
            filter
          })
        }
      })
    },
    confrimModal(id) {
      this.id = id
      this.$refs.confirmInbound.show()
    },
    seeDetail(id) {
      this.$router.push({
        name: 'warehouseDetail',
        params: {
          type: this.$route.params.type,
          id: id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.redwhite {
  width: 150px;
  height: 36px;
  color: #c4232a;
  border: 1px solid #c4232a;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: #ffffff;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: -0.011em;
}
.bluewhite {
  width: 150px;
  height: 36px;
  color: #fff;
  border: 1px solid #1d3354;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: #1d3354;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: -0.011em;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouse/inbound/List.vue